export class SchedulerTaskValueObjectCollection {

  constructor () {
    /**
     *
     * @type {*[]}
     * @private
     */
    this._items = []
  }

  get items () {
    return this._items
  }

  /**
   *
   * @param item
   */
  push (item) {
    this._items.push(item)
  }
}
